<template>
  <div>
    <h6 class="text-two">
      {{ question.semiology_form_question_type_description }}
    </h6>
    <div
      class="form-check"
      v-for="(item, key) in question.alternatives"
      :key="key"
    >
      <input
        class="form-check-input"
        type="radio"
        :id="`single-choice-${item.id}`"
        :name="`${category_id}-${question.id}-single-choice`"
        :value="item.id"
        @input="emit($event.target.value)"
      />
      <label class="form-check-label" :for="`single-choice-${item.id}`">
        {{ item.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: {
    category_id: [String, Number],
  },
  data() {
    return {
      question: {},
      answer: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    retrieve() {
      let { question } = this.$attrs;

      this.question = question;

      let answer = [];

      question.alternatives.map((item) =>
        answer.push({
          id: item.id,
          checked: false,
        })
      );

      this.answer = answer;
    },
    emit(answer) {
      this.$emit("answer", {
        category_id: this.category_id,
        id: this.question.id,
        answer,
      });
    },
  },
};
</script>
